<script>
  export let group;
</script>

<svelte:head>
  {#if group}
    <title>{group.name}</title>
    <meta name="url" content={group.url} />
    <meta property="og:title" content={group.name} />
    <meta property="og:description" content={group.description} />
    {@html `<meta property="og:image" content="https://image-proxy.benable.com/x/plain/${encodeURIComponent(group.og_url)}" />`}
    {@html `<meta name="twitter:image" content="https://image-proxy.benable.com/x/plain/${encodeURIComponent(group.og_url)}" />`}
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="628" />
    <meta name="twitter:site" content="@Benable_HQ" />
    <meta name="twitter:card" content="summary_large_image" />
  {/if}
</svelte:head>
